// extracted by mini-css-extract-plugin
export default {"box":"login_box__KTdJq","form":"login_form__BxgAM","label":"login_label__Yfkv7","title":"login_title__V-yKH","input":"login_input__IXs4x","btn":"login_btn__sboiv"};